module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5tTT9"))).then(() => parcelRequire('37nVf'));